import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "stretch",
    minHeight: 560,
  },
  leftPanel: {
    width: 400,
    maxWidth: 400,
    flexShrink: 0,
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    minHeight: 560,
    overflow: "hidden",
    borderRadius: "0 0 0 6px",
  },
  tabs: {
    width: "100%",
    maxWidth: "100%",
    minHeight: 48,
    boxSizing: "border-box",
  },
  tabsFlexContainer: {
    width: "100%",
  },
  tabRoot: {
    minWidth: 0,
    maxWidth: "33.33%",
    padding: theme.spacing(0.5, 1),
  },
  searchInput: {
    padding: 0,
  },
  searchRow: {
    display: "flex",
    alignItems: "center",
    gap: `${theme.spacing(0.75)}px`,
  },
  searchField: {
    flex: 1,
    minWidth: 0,
  },
  filterButton: {
    flexShrink: 0,
    width: 36,
    height: 36,
    padding: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
  },
  filterButtonActive: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    backgroundColor: "rgba(25, 118, 210, 0.08)",
  },
  teacherFiltersPanel: {
    display: "flex",
    flexDirection: "column",
    gap: `${theme.spacing(2)}px`,
    paddingTop: theme.spacing(2),
  },
  teacherFilterControl: {
    width: "100%",
    "& .MuiInputLabel-root": {
      fontSize: 16,
    },
    "& .MuiSelect-root": {
      fontSize: 16,
    },
  },
  teacherFilterRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: `${theme.spacing(0.75)}px`,
  },
  teacherFilterRowControl: {
    flex: 1,
    minWidth: 0,
  },
  invertSelectionButton: {
    flexShrink: 0,
    width: 40,
    height: 40,
    marginTop: 0,
    padding: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
  },
  listArea: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  listScrollContainer: {
    flex: 1,
    minHeight: 0,
    overflowX: "auto",
    overflowY: "hidden",
  },
  sectionLabel: {
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.grey[100],
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.5,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
  },
  listItem: {
    paddingTop: 4,
    paddingBottom: 4,
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
  listItemText: {
    flex: "0 0 auto",
    overflow: "visible",
  },
  selectedItem: {
    backgroundColor: theme.palette.action.selected,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 700,
    color: "#fff",
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  examAvatar: {
    backgroundColor: theme.palette.primary.main,
  },
  teacherAvatar: {
    backgroundColor: theme.palette.secondary.main,
  },
  schoolAvatar: {
    backgroundColor: theme.palette.info.main,
  },
  rightPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 560,
    borderRadius: "0 0 6px 0",
  },
  composeHeader: {
    flexShrink: 0,
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    gap: `${theme.spacing(0.5)}px`,
  },
  composeHeaderTitle: {
    flex: 1,
  },
  recipientsInfoButton: {
    padding: 4,
    color: theme.palette.text.secondary,
  },
  recipientsInfoTooltip: {
    maxWidth: 360,
    fontSize: 12,
    lineHeight: 1.5,
  },
  toRow: {
    flexShrink: 0,
    display: "flex",
    alignItems: "flex-start",
    alignSelf: "stretch",
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexWrap: "wrap",
    gap: `${theme.spacing(0.5)}px`,
    minHeight: 48,
  },
  toRowEmpty: {
    alignItems: "center",
  },
  toLabel: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
    marginTop: 4,
    color: theme.palette.text.secondary,
    fontSize: 14,
    flexShrink: 0,
  },
  toLabelEmpty: {
    marginTop: 0,
  },
  clearAllButton: {
    fontSize: 13,
    textTransform: "none",
    padding: theme.spacing(0.25, 0.5),
    minWidth: 0,
    flexShrink: 0,
    marginTop: 2,
    textDecoration: "underline",
  },
  chip: {
    height: 28,
    color: "#fff",
    "& .MuiChip-deleteIcon": {
      color: "rgba(255, 255, 255, 0.7)",
    },
    "& .MuiChip-deleteIcon:hover": {
      color: "#fff",
    },
  },
  chipExam: {
    "&.MuiChip-root": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
    "&.MuiChip-root:hover, &.MuiChip-root:focus": {
      backgroundColor: theme.palette.primary.dark,
      color: "#fff",
    },
  },
  chipTeacher: {
    "&.MuiChip-root": {
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
    },
    "&.MuiChip-root:hover, &.MuiChip-root:focus": {
      backgroundColor: theme.palette.secondary.dark,
      color: "#fff",
    },
  },
  subjectRow: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  subjectLabel: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: 14,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  bodyArea: {
    flex: 1,
    minHeight: 300,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  quillEditor: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    "& .ql-toolbar": {
      border: "none",
    },
    "& .ql-container": {
      flex: 1,
      overflow: "auto",
      border: "none",
    },
    "& .ql-editor": {
      fontSize: 14,
      minHeight: 260,
    },
  },
  footer: {
    flexShrink: 0,
    padding: theme.spacing(1.5, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  recipientCount: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  snackbarSuccess: {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: theme.palette.success.main,
    color: "#fff",
    fontSize: 14,
    fontWeight: 500,
  },
  snackbarWarning: {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    fontSize: 14,
    fontWeight: 500,
  },
  confirmTable: {
    maxHeight: 360,
  },
  copyEmailButton: {
    transition: theme.transitions.create(
      ["transform", "background-color", "color"],
      {
        duration: theme.transitions.duration.short,
      },
    ),
    "&:hover": {
      transform: "scale(1.12)",
      backgroundColor: "rgba(25, 118, 210, 0.1)",
    },
    "&:active": {
      transform: "scale(0.92)",
    },
  },
  copyEmailButtonPulse: {
    animation: "$copyEmailPulse 0.65s ease",
    color: theme.palette.success.main,
    backgroundColor: "rgba(46, 125, 50, 0.12)",
  },
  copyEmailIcon: {
    display: "inline-flex",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  copyEmailIconPop: {
    animation: "$copyEmailIconPop 0.5s ease",
  },
  "@keyframes copyEmailPulse": {
    "0%": { transform: "scale(1)" },
    "30%": { transform: "scale(1.4)" },
    "55%": { transform: "scale(0.95)" },
    "100%": { transform: "scale(1)" },
  },
  "@keyframes copyEmailIconPop": {
    "0%": { transform: "scale(0.6) rotate(-20deg)", opacity: 0.4 },
    "50%": { transform: "scale(1.25) rotate(8deg)", opacity: 1 },
    "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
  },
}));

export type Classes = ReturnType<typeof useStyles>;
